import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import PropTypes from 'prop-types';

import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
} from '../../../utils/constant';
import { certsFormattedMessage, getMessageKey } from '../../../utils/utils';
import { BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS } from '../constant';

import {
  BULK_ACTION_FOOTER_BTNS_REVERSE,
  getBulkActionFooterBtns,
} from './constant';

function BulkActionReassignHeader({ id, bulkFooterStats }) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const {
    core: { campaignType },
    lineActions: { reassignConfigMap },
  } = useSelector((state) => state?.certifications?.details);
  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;
  const buttonKey = BULK_ACTION_FOOTER_BTNS_REVERSE?.[id];
  const buttonObjectsForTotal = getBulkActionFooterBtns(
    campaignType,
    reassignConfigMap
  )[buttonKey]?.objectsToTotal;
  const count = buttonObjectsForTotal?.reduce((total, item) => {
    if (bulkFooterStats[item]) {
      return total + bulkFooterStats[item];
    }

    return total;
  }, 0);

  const userMessageKey = isEOCampaign
    ? BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS[
        `Entitlement${count > 1 ? 's' : ''}`
      ]
    : BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS[`User${count > 1 ? 's' : ''}`];

  const itemMessageKey = count > 1 ? 'CERTS_BULK_ITEMS' : 'CERTS_BULK_ITEM';

  const messageKey =
    id ===
    getBulkActionFooterBtns(campaignType, reassignConfigMap)
      .DOES_NOT_WORK_FOR_ME.id
      ? userMessageKey
      : itemMessageKey;

  return certsFormattedMessage(
    messages.CERT_BULK_REASSIGN_HEADER ||
      localize(intl, getMessageKey('CERT_BULK_REASSIGN_HEADER')),
    {
      count: count || 0,
      title: messages.messageKey || localize(intl, getMessageKey(messageKey)),
    }
  );
}

BulkActionReassignHeader.propTypes = {
  id: PropTypes.string.isRequired,
  bulkFooterStats: PropTypes.shape({}),
};

BulkActionReassignHeader.defaultProps = { bulkFooterStats: {} };

export default BulkActionReassignHeader;
